/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import Tooltip from 'rc-tooltip'
import _ from 'common-tools/LodashHelper'

import styles from './FAIcon.less'

export class FAIcon extends React.Component {
  static pt = {
    name: pt.string.isRequired,
    type: pt.string,
    color: pt.string,
    className: pt.string,
    onClick: pt.func,
    style: pt.object,
    spin: pt.bool,
    toolTip: pt.string,
    fixedWidth: pt.bool,
    placement: pt.string,
    overlayClassName: pt.string,
    size: pt.string,
    htmlToolTip: pt.bool,
    stopBubbleClicks: pt.bool,
    isCustom: pt.bool
  }

  static defaultProps = {
    placement: 'top',
    size: '18px',
    htmlToolTip: false,
    stopBubbleClicks: false
  }

  onClick (e) {
    const { onClick, stopBubbleClicks } = this.props

    if (stopBubbleClicks) {
      e.preventDefault()
      e.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()
    }
    if (_.isFunction(onClick) === true) {
      onClick(e)
    }
  }

  render () {
    const { 'data-tid': testId = '', name, size, className, noFocus, color, style, type, spin, toolTip, fixedWidth, placement, overlayClassName, htmlToolTip, isCustom } = this.props

    let iconStyle = _.merge({}, style)

    if (size) {
      iconStyle.fontSize = size
    }

    const colorClassName = color ? styles[`${color}`] : ''

    if (isCustom) {
      var iconProps = {
        'data-tid': testId,
        onClick: this.onClick.bind(this),
        style: iconStyle,
        className: `icon-${name}`
      }
    } else {
      var iconProps = {
        'data-tid': testId,
        onClick: this.onClick.bind(this),
        style: iconStyle,
        className: `fa${type || 's'} fa-${name} ${className || ''} ${spin ? 'fa-spin' : ''} ${fixedWidth ? 'fa-fw' : ''}`
      }
    }

    if (noFocus) {
      iconProps.tabIndex = -1
    }

    const icon = <span className={`${colorClassName}`}><i {...iconProps}></i></span>

    if (toolTip) {
      return (
        <Tooltip mouseEnterDelay={0.5} placement={placement} overlayClassName={`${overlayClassName || ''} ${color || ''}`} overlay={htmlToolTip ? <span dangerouslySetInnerHTML={{ __html: toolTip }}></span> : toolTip}>
          {icon}
        </Tooltip>
      )
    } else {
      return icon
    }
  }
}
